import React, { useState, useEffect, useRef } from "react";
import { Prompt } from "react-router";
import { useHistory, useParams } from "react-router-dom";
import {
  Form,
  Input,
  Button,
  Space,
  Row,
  Col,
  Menu,
  Dropdown,
  Spin,
  Typography,
  Tag,
  message,
  Tooltip,
  Popconfirm,
  Divider,
} from "antd";
import { checkInvType } from "./helperPatt/showFieldByType";
import {
  getNewCode,
  initiale,
  editPattInv,
  getInvPattById,
} from "../../../services/InvPatService";
import {
  getByInvPatt,
  deleteInvPattSett,
} from "../../../services/InvPatSettService";
import DataGrid from "react-data-grid";
import SelectSingle from "../../helper/selectSingle";
import {
  RetweetOutlined,
  PlusOutlined,
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";
import _t from "../../../languages/translate";
import { handleEx } from "../../helper/handleException";
import { getAuth } from "../../../services/Authorization/userRoleService";
import { authKeys } from "../../../services/Authorization/authKeys";
import { shortCut } from "../../helper/shortCuts";
import LinkToBranch from "./helperPatt/popups/linkToBranch";
import PattSettings from "./helperPatt/InvPattSettings";

const InvPattForm = () => {
  const IX_Code = useRef(null);
  const IX_NameAr = useRef(null);
  const IX_NameEn = useRef(null);
  const [loading] = useState(false);
  const [loadData, setLoadData] = useState(true);
  const [selectedPattren, setSelectedPattren] = useState(undefined);
  const [dataObj, setDataObj] = useState(undefined);
  const [selectedTypeId, setSelectedTypeId] = useState(undefined);
  const [showLinkToBransh, setShowLinkToBransh] = useState(false);
  const [detailsCol, setDetailsCol] = useState(false);
  const [discsCol, setDiscsCol] = useState(false);
  const [addsCol, setAddsCol] = useState(false);
  const [branchDataSource, setBranchDataSource] = useState([]);
  const [invPattSettId, setInvPattSettId] = useState(undefined);

  const [form] = Form.useForm();
  let history = useHistory();
  let { id } = useParams();
  const [isGoBack, setIsGoBack] = useState(true);
  const { Text } = Typography;

  //////////----|👉 start auth|----//////////
  const [auth, setAuth] = useState({});
  const authorization = async () => {
    const obj = JSON.parse(localStorage.getItem("auth"));
    if (obj !== null) {
      const responce = obj.filter((e) => e?.roleKey === authKeys.finalAcc)[0];
      setAuth(responce);
    } else {
      try {
        const data = await getAuth();
        localStorage.setItem("auth", JSON.stringify(data.data.data));
        authorization();
      } catch (ex) {
        return null;
      }
    }
  };
  //////////----|👉 end auth|----//////////
  const codeGenerator = async () => {
    setLoadData(true);
    const { data: newData } = await getNewCode();
    form.setFieldsValue({ code: newData.data });
    IX_NameAr.current.focus();
    setLoadData(false);
  };

  const handleGetBranchesCol = async () => {
    try {
      const { data: data } = await getByInvPatt(id);
      setBranchDataSource(data.data);
    } catch (error) {
      handleEx(error);
    }
  };

  useEffect(() => {
    async function fetchData() {
      if (id === "new") {
        return await codeGenerator();
      } else {
        try {
          const { data } = await getInvPattById(id);
          form.setFieldsValue({
            id: data.data.Id,
            invPattSettId: data.data.invPattSettId,
            code: data.data.code,
            nameAr: data.data.nameAr,
            nameEn: data.data.nameEn,
            invTypeId: data.data.invTypeId,
          });
          setDataObj(data);
          setSelectedTypeId(data.data.invTypeId);
          setSelectedPattren(data.data.invTypeId);
          handleGetBranchesCol();
          IX_NameAr.current.focus();
        } catch (error) {
          handleEx(error, { IX_Code, IX_NameAr, IX_NameEn });
        } finally {
          setLoadData(false);
        }
      }
    }
    fetchData();
  }, [id, history, setLoadData]);

  //******************************// //*******************// Back //*******************// //******************************//

  const menu = (
    <Menu>
      <Menu.Item onClick={() => setIsGoBack(true)}>
        {_t("strLeaveThePage")}
      </Menu.Item>
      <Menu.Item onClick={() => setIsGoBack(false)}>
        {_t("strStayInPage")}
      </Menu.Item>
    </Menu>
  );

  const goBack = (objId) => {
    if (objId !== true) {
      history.replace({ ...history.location, pathname: `/invPatt/${objId}` });
      IX_NameAr.current.focus();
    }
  };

  //******************************// //*******************// Save //*******************// //******************************//

  const onFinish = async (values) => {
    setLoadData(true);
    setProChange(false);
    values.id = id;
    sessionStorage.removeItem("popup_invTableSett");
    sessionStorage.removeItem("popup_addTableSett");
    sessionStorage.removeItem("popup_discTableSett");
    // values.detailsColSett= values.detailsColSett.filter(e=>e.visible === true);

    try {      
      const data = await editPattInv(values);
      message.success(data.data.message, 3);
      goBack(data?.data?.data);
    } catch (error) {
      setLoadData(false);
      handleEx(error, { IX_Code, IX_NameAr, IX_NameEn });
    } finally {
      setLoadData(false);
    }
  };

  const [altPress, setAltPress] = useState(false);

  useEffect(() => {
    const handleKeydownOnEdit = (e) => {
      const confState = JSON.parse(window.sessionStorage.getItem("confState"));
      let showModal = JSON.parse(window.sessionStorage.getItem("showModal"));
      if (showModal === false || showModal === null) {
        if (!confState) {
          switch (shortCut(e)) {
            case "save":
              form.submit();
              break;
            case "search":
              IX_Code?.current?.focus();
              IX_Code?.current?.select();
              break;
            case "block1":
              IX_NameAr?.current?.focus();
              break;
            case "tag":
              setAltPress(true);
              break;
            default:
              break;
          }
        }
      }
    };
    window.addEventListener("keydown", handleKeydownOnEdit);
    return () => {
      window.removeEventListener("keydown", handleKeydownOnEdit);
    };
  }, []);

  useEffect(() => {
    const handleKeydownOnEdit = (e) => {
      if (e.keyCode === 18) {
        setAltPress(false);
      }
    };
    window.addEventListener("keyup", handleKeydownOnEdit);
    return () => {
      window.removeEventListener("keyup", handleKeydownOnEdit);
    };
  }, []);

  useEffect(() => {
    const handleKeydownOnEdit = (e) => {
      setAltPress(false);
    };
    window.addEventListener("blur", handleKeydownOnEdit);
    return () => {
      window.removeEventListener("blur", handleKeydownOnEdit);
    };
  }, []);

  //******************************// //*******************// Form Code //*******************// //******************************//

  const [proChange, setProChange] = useState(false);
  const promptForm = () => {
    setProChange(true);
  };

  const handelChangeType = async (e) => {
    try {
      setSelectedPattren(e);
      setSelectedTypeId(e);
      //const obj = await checkInvType(e);
      if (e !== undefined) {
        const { data: data } = await initiale(e);
        setDataObj(data);
      }
    } catch (error) {
      setLoadData(false);
      handleEx(error);
    }
  };

  const finishLink = () => {
    handleGetBranchesCol();
    setInvPattSettId(undefined);
  };
  const deleteBranch = async (objId) => {
    await deleteInvPattSett(objId);
    await handleGetBranchesCol();
  };

  //******************************// //*******************// Form //*******************// //******************************//

  return (
    <React.Fragment>
      <LinkToBranch
        showModal={showLinkToBransh}
        setShowModal={setShowLinkToBransh}
        selectedTypeId={selectedTypeId}
        invPattSettId={invPattSettId}
        invPattId={id}
        onFinishLink={finishLink}
      />

      <Prompt when={proChange} message={_t("strUnsavedChanges")} />
      <Spin spinning={loadData} tip={_t("strLoading")}>
        <Form
          form={form}
          name="itemUnitform"
          onFinish={onFinish}
          layout="horizontal"
          onSubmit={(e) => {
            e.preventDefault();
          }}
          labelCol={{
            flex: "150px",
          }}
          wrapperCol={{
            span: 50,
          }}
        >
          <Form.Item name="invPattSettId" hidden>
            <Input />
          </Form.Item>
          <div name="code" className="frHeader">
            <Row>
              <Col xs={24} md={24}>
                <Space split="#">
                  <Space split="\">
                    <Text>{_t("strPatterns")}</Text>
                    <Text style={{ fontWeight: 700 }}>
                      {_t("strInvPatterns")}
                    </Text>
                  </Space>
                  <div>
                    <Form.Item
                      name="code"
                      rules={[
                        { required: true, message: `${_t("strIsRequired")}` },
                        { min: 1, message: `${_t("strFrom3-200")}` },
                        { max: 200, message: `${_t("strFrom3-200")}` },
                      ]}
                      normalize={(value) => value.trimStart()}
                    >
                      <Input
                        className="inpCode"
                        size="small"
                        placeholder={_t("strCode")}
                        maxLength={200}
                        autoComplete="off"
                        onChange={promptForm}
                        ref={IX_Code}
                        bordered={false}
                      />
                    </Form.Item>
                    <div
                      style={{
                        opacity: 0.8,
                        zIndex: 99,
                        position: "absolute",
                        top: 24,
                      }}
                    >
                      <Tag color="#2b2b2b" hidden={!altPress}>
                        alt + F
                      </Tag>
                    </div>
                  </div>
                </Space>
              </Col>
            </Row>
          </div>
          <Row gutter={6}>
            {id !== "new" && (
              <Col xs={24} md={6}>
                <div
                  name="field"
                  className="frContent"
                  style={{ height: "100%" }}
                >
                  <Button
                    type="dashed"
                    block
                    icon={<PlusOutlined />}
                    onClick={() => {
                      setShowLinkToBransh(true);
                    }}
                  >
                    {_t("strAdd")}
                  </Button>
                  <div style={{ marginTop: 10 }}>
                    <DataGrid
                      //ref={innerRef}
                      columns={[
                        {
                          name: "#",
                          key: "num",
                          minWidth: 30,
                          width: 43,
                        },
                        {
                          name: _t("strBranch"),
                          key: "branchName",
                        },
                        {
                          name: _t("strActions"),
                          key: "action",
                          minWidth: 75,
                          width: 100,
                          formatter: (p) => {
                            return (
                              <>
                                <Tooltip title={_t("strEdit")} color="#6c63ff">
                                  <EditOutlined
                                    style={{ color: "#6c63ff" }}
                                    onClick={() => {
                                      setInvPattSettId(p?.row?.id);
                                      setShowLinkToBransh(true);
                                    }}
                                  />
                                </Tooltip>

                                <Divider type="vertical" />

                                <Popconfirm
                                  title={_t("strSureToDelete")}
                                  onConfirm={() => deleteBranch(p.row.id)}
                                >
                                  <DeleteOutlined
                                    style={{ color: "#EC2867" }}
                                  />
                                </Popconfirm>
                              </>
                            );
                          },
                        },
                      ]}
                      rows={branchDataSource?.map(
                        (e, i) => (e = { ...e, num: i + 1 })
                      )}
                      rowHeight={25}
                      className="rdg-light"
                      defaultColumnOptions={{
                        sortable: true,
                        resizable: true,
                      }}
                      direction={_t("langDiriction")}
                    />
                  </div>
                </div>
              </Col>
            )}

            <Col xs={24} md={id !== "new" ? 18 : 24}>
              <div name="field" className="frContent">
                <Row gutter={12}>
                  <Col xs={24} md={8}>
                    <Form.Item
                      name="nameAr"
                      label={
                        <div>
                          {_t("strNameAr")}
                          <div
                            style={{
                              opacity: 0.8,
                              zIndex: 99,
                              position: "absolute",
                              top: 4,
                            }}
                          >
                            <Tag color="#2b2b2b" hidden={!altPress}>
                              alt + 1
                            </Tag>
                          </div>
                        </div>
                      }
                      rules={[
                        { required: true, message: `${_t("strIsRequired")}` },
                        { min: 1, message: `${_t("strFrom3-200")}` },
                        { max: 200, message: `${_t("strFrom3-200")}` },
                      ]}
                      normalize={(value) => value.trimStart()}
                    >
                      <Input
                        placeholder={_t("strNameAr")}
                        maxLength={200}
                        autoComplete="off"
                        size="small"
                        onChange={promptForm}
                        ref={IX_NameAr}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8}>
                    <Form.Item
                      name="nameEn"
                      label={_t("strNameEn")}
                      rules={[
                        { required: true, message: `${_t("strIsRequired")}` },
                        { min: 1, message: `${_t("strFrom3-200")}` },
                        { max: 200, message: `${_t("strFrom3-200")}` },
                      ]}
                      normalize={(value) => value.trimStart()}
                    >
                      <Input
                        placeholder={_t("strNameEn")}
                        maxLength={200}
                        autoComplete="off"
                        size="small"
                        onChange={promptForm}
                        ref={IX_NameEn}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8}>
                    <Form.Item
                      name="invTypeId"
                      label={_t("strType")}
                      labelCol={{ flex: "85px" }}
                    >
                      <SelectSingle
                        allowClear
                        opt={[
                          {
                            id: "b06e5b92-b19e-45b1-9c25-1fb51f8f2b5e",
                            name: _t("strPurchases"),
                            filter1: _t("strPurchases"),
                          },
                          {
                            id: "51807f8b-9e03-498e-8f90-b634273b5c4b",
                            name: _t("strSales"),
                            filter1: _t("strSales"),
                          },
                          {
                            id: "c81f2a29-b52b-433b-b107-655342313007",
                            name: _t("strRepurchases"),
                            filter1: _t("strRepurchases"),
                          },
                          {
                            id: "4ca23e8b-63f5-4147-92ef-3cd45a1c9145",
                            name: _t("strResales"),
                            filter1: _t("strResales"),
                          },
                          {
                            id: "17ccdbca-cc1b-47bf-8d87-411277026ca2",
                            name: _t("strEntry"),
                            filter1: _t("strEntry"),
                          },
                          {
                            id: "678c6cc0-bb0a-4065-89e2-2265b2ce37df",
                            name: _t("strOutput"),
                            filter1: _t("strOutput"),
                          },
                          {
                            id: "38e83484-c6a5-4245-ab3c-a8091cdd2d54",
                            name: _t("strOpeningInventory"),
                            filter1: _t("strOpeningInventory"),
                          },
                          {
                            id: "626182e0-32ac-4af2-9b77-5fb7ffbd46f0",
                            name: _t("strStoreTransfer"),
                            filter1: _t("strStoreTransfer"),
                          },
                        ]}
                        onChange={(e) => {
                          // setSelectedPattren(e);
                          handelChangeType(e);
                        }}
                        placeholder={_t("strType")}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </div>
              {selectedPattren !== undefined && (
                <PattSettings
                  form={form}
                  dataObj={dataObj}
                  selectedTypeId={selectedTypeId}
                  showLinkToBransh={showLinkToBransh}
                  detailsCol={detailsCol}
                  discsCol={discsCol}
                  addsCol={addsCol}
                  setDetailsCol={setDetailsCol}
                  setDiscsCol={setDiscsCol}
                  setAddsCol={setAddsCol}
                  setLoadData={setLoadData}
                  // selectedPattren={selectedPattren}
                  // setSelectedPattren={setSelectedPattren}
                />
              )}
            </Col>
          </Row>
          <div
            className="frFooter"
            style={id !== "new" ? { marginTop: 3 } : {}}
          >
            <Form.Item>
              <Space size="large">
                {!auth?.perPut && (
                  <div>
                    <Button
                      type="primary"
                      size="small"
                      onClick={() => {
                        form.submit();
                      }}
                      //  htmlType="submit"
                      disabled={loading}
                    >
                      {_t("strSave")}
                    </Button>
                    <div
                      style={{
                        opacity: 0.8,
                        zIndex: 99,
                        position: "absolute",
                        top: 24,
                      }}
                    >
                      <Tag color="#2b2b2b" hidden={!altPress}>
                        alt + S
                      </Tag>
                    </div>
                  </div>
                )}
                <Button
                  hidden={typeof onNewStore === "function"}
                  onClick={() => {
                    history.action === "PUSH"
                      ? history.goBack()
                      : history.push("/invPatt");
                  }}
                  size="small"
                >
                  {_t("strBack")}
                </Button>
              </Space>
            </Form.Item>
          </div>
        </Form>
      </Spin>
    </React.Fragment>
  );
};

export default InvPattForm;
